export default class telGroupCollection{
    constructor(options) {
        this.cache(options)
        this.init()
        return this
    }
    
    cache(options) {
        this.settings = {
            ...this.defaults,
            ...options
        }
    }
    
    get defaults() {
        return {
            groups: [],
        }
    }
    get groups() {
        return this.settings.groups
    }
    
    init() {
        this.events()
    }
    events() {
        
    }

    push (telGroup) {
        telGroup.sort()
        this.groups.push(telGroup)
    }

    getGroupByName(name) {
        return this.groups.find(group => group.name === name)
    }

    getGroupById(id) {
        return this.groups.find(group => group.id === id)
    }

    switchGroups(options) {
        const prevList = this.getGroupById(options.prev_list)
        const currentList = this.getGroupById(options.list)
        
        const tempUser = prevList.getUserById(options.user_id)
        
        if(!tempUser) {
            console.error('tempUser not found', options)
            return false
        }
        tempUser.status = options.status
        tempUser.color = options.color
        tempUser.has_incoming = options.has_incoming
        prevList.removeItemById(options.user_id)
        
        currentList.addItem(tempUser)
        prevList.sort()
        currentList.sort()
        return true
    }
}